module.exports = __webpack_public_path__ + "static/media/ClientPanel_4.364f8dba.webp";